// extracted by mini-css-extract-plugin
export default {"wrapper":"Pool_wrapper__CLmGh","card":"Pool_card__foof1","amount":"Pool_amount__rxx1t","title":"Pool_title__ENI+4","chartCard":"Pool_chartCard__vh50Q"};